import {
    Logout
} from '../Slice/Business';
import { AsyncAjaxGet } from "../Common/AsyncAjaxService";
import store from '../../app/store'
import { ResponseCode, utils } from "../../utils/Utils";

const useSession = async (useDispatch, BusinessID, UserID, SessionCallBack) => {
    const IsEnableSession = true;
    const dispatch = useDispatch;
    const { access_token } = store.getState().Token;
    var GetSessionURL = "merchants/" + BusinessID + "/session";
    if (IsEnableSession) {
        if (utils.Validate(UserID)) {
            await AsyncAjaxGet(
                GetSessionURL + "?encUserID=" + UserID,
                access_token,
                function onSuccess(data) {
                    try {
                        if (
                            data != null &&
                            data.data != null &&
                            data.data.responseCode == ResponseCode.Success
                        ) {
                            if (data != null && data.data != null && data.data.data != null) {
                                var currentDate = data.data.data.currentDate;
                                var expireDate = data.data.data.expireDate;
                                if (currentDate < expireDate) {
                                    SessionCallBack(true);
                                }
                                else {
                                    dispatch(Logout());
                                    window.location.href = "https://www.vagaro.com/login";
                                }
                            }
                            else {
                                dispatch(Logout());
                                window.location.href = "https://www.vagaro.com/login";
                            }
                        }
                        else {
                            dispatch(Logout());
                            window.location.href = "https://www.vagaro.com/login";
                        }
                    }
                    catch (error) {
                        dispatch(Logout());
                        window.location.href = "https://www.vagaro.com/login";
                    }
                },
                function OnError() {
                    dispatch(Logout());
                    window.location.href = "https://www.vagaro.com/login";
                }
            )
        }
    }
    else {
        SessionCallBack(true);
    }
};

export default useSession;